const typeNames = {
    EIN: 'EIN',
    BN: 'BN',
    CBN: 'CBN',
};

export default typeNames;
